<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font md:ml-4">Alumni Office Contact</h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <section class="flex-1 shadow-lg border-2 border-gray-200 rounded-lg aarni-font">
            <div class="bg-gradient-to-r from-green-300 to-cyan-700 text-white px-6 py-12 text-center">
                <h1 class="text-2xl font-bold">ARNI University</h1>
                <p class="text-lg">List of Alumni Coordinators</p>
            </div>

            <h3 class="text-xl font-semibold my-4 px-6">Alumni Cell</h3>
            <div class="overflow-x-auto px-6 mb-8">
                <table class="min-w-full border border-gray-400 text-lg mb-8">
                    <thead class="bg-gray-100">
                    <tr>
                        <th class="border border-gray-400 px-4 py-2">No.</th>
                        <th class="border border-gray-400 px-4 py-2">Name of School</th>
                        <th class="border border-gray-400 px-4 py-2">Category</th>
                        <th class="border border-gray-400 px-4 py-2 w-72">Details</th> <!-- Increased width -->
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let item of alumniOfficeContacts; let i = index">
                        <tr>
                            <td class="border px-4 py-2" [attr.rowspan]="2"> {{ i + 1 }}</td>
                            <td class="border px-4 py-2 font-bold text-lg" [attr.rowspan]="2"> {{ item.school }}</td>
                            <td class="border px-4 py-2 font-semibold">{{ item.designation }}</td>
                            <td class="border px-4 py-2 w-72"> {{ item.name }}</td> <!-- Apply same width -->
                        </tr>
                        <tr>
                            <td class="border px-4 py-2 font-semibold">Email</td>
                            <td class="border px-4 py-2 w-72"> {{ item.email }}</td> <!-- Apply same width -->
                        </tr>
                    </ng-container>
                    </tbody>
                </table>
            </div>
        </section>

        <aside class="w-full lg:w-1/4 space-y-4 max-h-screen overflow-y-auto overflow-x-hidden pr-2 hidden md:block">
            <div class="border-t-8 border-cyan-700">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Get To Know ARNI</h2>
                    <div class="">
                        <a [href]="'about/about-us'"
                           class="flex items-center space-x-2 p-3 w-full text-cyan-700 border-b border-gray-30 cursor-pointer0 hover:bg-cyan-700 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i><span>Overview & Identity</span>
                        </a>
                        <a [href]="'about/core-values'"
                           class="flex items-center space-x-2 p-3 w-full text-cyan-700 border-b border-gray-300 cursor-pointer hover:bg-cyan-700 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i><span>Core Values</span>
                        </a>
                        <a [href]="'about/mission-and-vision'"
                           class="flex items-center space-x-2 p-3 w-full text-cyan-700 border-b border-gray-300 cursor-pointer hover:bg-cyan-700 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i><span>Mission and Vision</span>
                        </a>
                        <a [href]="'about/leadership/chancellor'"
                           class="flex items-center space-x-2 p-3 w-full text-cyan-700 border-b border-gray-300 cursor-pointer hover:bg-cyan-700 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i><span>Leadership</span>
                        </a>
                        <a [href]="'about/faculty'"
                           class="flex items-center space-x-2 p-3 w-full text-cyan-700 border-b border-gray-300 cursor-pointer hover:bg-cyan-700 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i><span>Faculty</span>
                        </a>
                        <a [href]="'about/ai-integrated-program'"
                           class="flex items-center space-x-2 p-3 w-full text-cyan-700 cursor-pointer hover:bg-cyan-700 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i><span>AI Integrated Program</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
    </div>
</div>

